import styled from "styled-components";

export const Image = styled.img`
  width: 229px;
  height: 144px;
  margin-bottom: 29px;
`;
